import { styled, SvgIcon, SvgIconProps } from '@mui/material';
import { themeVars } from '../../../theme/themeVars';

export const checkboxIconClass = 'MdsCheckboxIcon';

const CheckboxIconRect = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'inline-flex',
  width: '100%',
  height: '100%',
  borderStyle: 'var(--mds-Checkbox-ringStyle, solid)',
  borderWidth: 1.5,
  borderRadius: theme.shape.borderRadius,
  borderColor: 'var(--mds-Checkbox-ringColor, currentColor)',
  background: 'var(--mds-Checkbox-fillColor, transparent)',
}));

const StyledSvgIcon = styled(SvgIcon)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  color: themeVars(theme).palette.background.default,
}));

export const CheckboxIcon = () => <CheckboxIconRect />;

export const CheckboxCheckedIcon = (props: SvgIconProps) => (
  <CheckboxIconRect className={checkboxIconClass}>
    <StyledSvgIcon viewBox="2 2 18 18" {...props}>
      <path
        d="M16.5595 8.24703L9.55953 15.247C9.5189 15.2877 9.47065 15.32 9.41754 15.342C9.36442 15.364 9.30749 15.3753 9.25 15.3753C9.1925 15.3753 9.13557 15.364 9.08246 15.342C9.02935 15.32 8.9811 15.2877 8.94047 15.247L5.87797 12.1845C5.79588 12.1024 5.74976 11.9911 5.74976 11.875C5.74976 11.7589 5.79588 11.6476 5.87797 11.5655C5.96006 11.4834 6.0714 11.4373 6.1875 11.4373C6.3036 11.4373 6.41494 11.4834 6.49703 11.5655L9.25 14.319L15.9405 7.62797C16.0226 7.54587 16.1339 7.49976 16.25 7.49976C16.3661 7.49976 16.4774 7.54587 16.5595 7.62797C16.6416 7.71006 16.6877 7.8214 16.6877 7.9375C16.6877 8.0536 16.6416 8.16494 16.5595 8.24703Z"
        fill="currentColor"
      />
    </StyledSvgIcon>
  </CheckboxIconRect>
);

export const CheckboxIndeterminateIcon = (props: SvgIconProps) => (
  <CheckboxIconRect className={checkboxIconClass}>
    <StyledSvgIcon viewBox="2 2 18 18" {...props}>
      <path
        d="M16.25 11C16.25 11.116 16.2039 11.2273 16.1219 11.3094C16.0398 11.3914 15.9285 11.4375 15.8125 11.4375H6.1875C6.07147 11.4375 5.96019 11.3914 5.87814 11.3094C5.79609 11.2273 5.75 11.116 5.75 11C5.75 10.884 5.79609 10.7727 5.87814 10.6906C5.96019 10.6086 6.07147 10.5625 6.1875 10.5625H15.8125C15.9285 10.5625 16.0398 10.6086 16.1219 10.6906C16.2039 10.7727 16.25 10.884 16.25 11Z"
        fill="currentColor"
      />
    </StyledSvgIcon>
  </CheckboxIconRect>
);
